import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SignalForm } from '@/components/signals';
import { useSignals, useTelegram } from '@/hooks';
import type { SignalFormData } from '@/components/signals/SignalForm';

export const CreateSignalPage: React.FC = () => {
  const navigate = useNavigate();
  const { createSignal, isLoading, error } = useSignals();
  const { showBackButton, hideBackButton, hideMainButton, showAlert } = useTelegram();

  // Set up back button
  useEffect(() => {
    showBackButton(() => navigate(-1));
    hideMainButton();

    return () => {
      hideBackButton();
    };
  }, [showBackButton, hideBackButton, hideMainButton, navigate]);

  const handleSubmit = async (data: SignalFormData) => {
    if (!data.asset) return;

    const result = await createSignal({
      symbol: data.asset.symbol,
      quoteCurrency: data.quoteCurrency,
      type: data.type,
      value: parseFloat(data.value),
      soundName: 'default',
      direction: data.direction,
      repeat: data.repeat,
      active: true,
    });

    if (result) {
      showAlert('Alert created successfully!');
      navigate('/signals', { replace: true });
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundColor: 'var(--tg-theme-bg-color)',
      }}
    >
      {/* Header */}
      <div
        style={{
          padding: '16px',
          borderBottom: '1px solid var(--tg-theme-secondary-bg-color)',
        }}
      >
        <h1
          style={{
            fontSize: '20px',
            fontWeight: 700,
            color: 'var(--tg-theme-text-color)',
            margin: 0,
          }}
        >
          Create Alert
        </h1>
      </div>

      {/* Error display */}
      {error && (
        <div
          style={{
            padding: '12px 16px',
            backgroundColor: 'rgba(255, 59, 48, 0.1)',
            color: '#ff3b30',
            fontSize: '14px',
          }}
        >
          {error}
        </div>
      )}

      {/* Form */}
      <SignalForm
        onSubmit={handleSubmit}
        isLoading={isLoading}
        submitLabel="Create Alert"
      />
    </div>
  );
};
